import coverImg from "assets/images/v91/cover.webp"

export const v91Config = {
  cover: {
    en: coverImg,
  },
}
